export default "__VITE_ASSET__BKbrLnKK__"